import { PublisherLogo } from '@ui/kit/icons';
import { wrapper, message, svg } from './loader.styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Loader(props) {
  return /*#__PURE__*/jsx("div", {
    ref: props.ref,
    className: wrapper,
    children: /*#__PURE__*/jsxs("span", {
      className: message,
      children: [/*#__PURE__*/jsx(PublisherLogo, {
        className: svg,
        small: true
      }), "Henter data..."]
    })
  });
}

export { Loader };
//# sourceMappingURL=loader.js.map
